module.exports = __webpack_public_path__ + "static/media/recorded-future.5e97d2c4.png";